import { Colormap, DVMNodes } from '@3ddv/ngx-sites-builder-lib';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SblibService } from '../../../services/sblib.service';
import { ToolsService } from '../../services/tools.service';
import { ColormapTemplate, default_colors } from '../models/default.model';

@Component({
  selector: 'app-custom',
  templateUrl: './custom.component.html',
  styleUrls: ['./custom.component.scss']
})
export class CustomComponent implements OnInit, OnDestroy {
  @Input() master_custom_colors: default_colors;
  @Input() template?: boolean;
  @Output() onTemplateUpdate = new EventEmitter<DVMNodes>();
  @Output() onTemplateCreate = new EventEmitter<ColormapTemplate>();
  @Output() onTemplateDestroy = new EventEmitter<boolean>();

  public subscriptions: Array<Subscription>;
  private tool: Colormap;
  public hiddenColors: {
    section?:boolean,
    seat?: boolean,
    areaprice?: boolean
  };
  public uploading: boolean = false;
  public createMode: boolean = false;
  public deleting: boolean = false;
  public createNewTemplate: ColormapTemplate = {
    name: '',
    values: {}
  };

  constructor(private sblibService: SblibService, private toolsService: ToolsService, private toastrService: ToastrService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const o$ = this.toolsService.getAsyncTools$().subscribe(res=>{
      this.tool = res.colormap;
    });
    this.subscriptions.push(o$);

    this.hiddenColors = {
      section:false,
      seat: false,
      areaprice: false
    };
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o=>o.unsubscribe());
  }

  //Deprecated
  public applyCustomStyles(){
    this.tool ={
      manual: {},
      default: false
    }

    for(let i = 0;i<this.master_custom_colors.styles.length;i++){
      if (this.master_custom_colors.styles[i].title === 'section'){
        this.tool.manual['section']=this.master_custom_colors.styles[i].styles;
      }
      if (this.master_custom_colors.styles[i].title === 'seat'){
        this.tool.manual['seat']=this.master_custom_colors.styles[i].styles;
      }
      if (this.master_custom_colors.styles[i].title === 'areaprice'){
        this.tool.manual['areaprice']=this.master_custom_colors.styles[i].styles;
      }
    }

    const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
      res.colormap = JSON.parse(JSON.stringify(this.tool));
      this.toastrService.success("","Success")
      this.sblibService.apply(res);
    });
    this.subscriptions.push(tools$);
  }

  public udpdateTemplate(templateValues: default_colors) {
    this.uploading = true;
    // parse to template values;
    const values: DVMNodes = {};

    templateValues.styles.forEach(layer=>{
      values[layer.title] = layer.styles;
    })
    this.onTemplateUpdate.emit(values);
  }

  public createTemplate(){
    this.uploading = true;
    this.master_custom_colors.styles.forEach(layer=>{
      if(layer.title){
       this.createNewTemplate.values[layer.title] = layer.styles;
      }
    })

    this.onTemplateCreate.emit(this.createNewTemplate);
  }

  public destroyTemplate(){
    this.onTemplateDestroy.emit()
  }

  public getTool(){
    this.tool ={
      manual: {},
      default: false
    }

    for(let i = 0;i<this.master_custom_colors.styles.length;i++){
      if (this.master_custom_colors.styles[i].title === 'section'){
        this.tool.manual['section']=this.master_custom_colors.styles[i].styles;
      }
      if (this.master_custom_colors.styles[i].title === 'seat'){
        this.tool.manual['seat']=this.master_custom_colors.styles[i].styles;
      }
      if (this.master_custom_colors.styles[i].title === 'areaprice'){
        this.tool.manual['areaprice']=this.master_custom_colors.styles[i].styles;
      }
    }
    return this.tool;
  }
}
